// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v4[data-v-f7230ba2]{min-height:100vh;font-size:16px;background-color:#f9f9f9;padding-bottom:20px;-webkit-box-sizing:border-box;box-sizing:border-box}", ""]);
// Exports
module.exports = exports;
